/* IRELIO theme: header, mobile menu, slide-out cart. No framework. */
(function () {
  var doc = document.documentElement;
  var R = (window.IRELIO && window.IRELIO.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- header: scrolled state + mobile menu ---------- */
  var hdr = document.querySelector('[data-header]');
  var menuBtn = document.getElementById('menubtn');
  var scrim = document.getElementById('scrim');

  function closeMenu() {
    if (!hdr) return;
    hdr.classList.remove('menu-open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    if (scrim) scrim.classList.remove('on');
    doc.classList.remove('scroll-lock');
  }
  if (menuBtn && hdr) {
    menuBtn.addEventListener('click', function () {
      var open = !hdr.classList.contains('menu-open');
      hdr.classList.toggle('menu-open', open);
      menuBtn.setAttribute('aria-expanded', String(open));
      if (scrim) scrim.classList.toggle('on', open);
      doc.classList.toggle('scroll-lock', open);
    });
  }
  if (scrim) scrim.addEventListener('click', closeMenu);
  window.addEventListener('resize', function () { if (window.innerWidth > 959) closeMenu(); });

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (hdr) hdr.classList.toggle('is-scrolled', window.scrollY > 40);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- cart drawer ---------- */
  var lastFocus = null;
  function drawer() { return document.getElementById('cart-drawer'); }

  /* while the drawer is open, the page behind it cannot be reached with Tab or a screen reader */
  function setInert(on) {
    var d = drawer(); if (!d) return;
    [].slice.call(document.body.children).forEach(function (el) {
      if (el.contains(d) || /^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(el.tagName)) return;
      if (on) { if (!el.hasAttribute('inert')) { el.setAttribute('inert', ''); el.setAttribute('data-was-inert', '1'); } }
      else if (el.getAttribute('data-was-inert')) { el.removeAttribute('inert'); el.removeAttribute('data-was-inert'); }
    });
  }

  function openCart() {
    var d = drawer();
    if (!d) return;
    closeMenu();
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    doc.classList.add('scroll-lock');
    setInert(true);
    var c = d.querySelector('[data-cart-close].iconbtn');
    if (c) c.focus({ preventScroll: true });
  }
  function closeCart() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    doc.classList.remove('scroll-lock');
    setInert(false);
    /* give focus back to what opened the cart; if that was a button that was disabled at the time, use the Add to cart or cart button instead */
    var back = (lastFocus && lastFocus !== document.body && !lastFocus.disabled && document.contains(lastFocus)) ? lastFocus : (document.querySelector('[data-add]') || document.querySelector('[data-cart-open]'));
    if (back && back.focus) back.focus({ preventScroll: true });
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var was = el.textContent;
      el.textContent = n;
      el.hidden = !(n > 0);
      if (String(was) !== String(n) && n > 0) { el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); }
    });
  }

  /* put freshly rendered drawer html on the page; returns the item count when the html carries it */
  function applyDrawer(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-cart-inner]');
    var cur = document.querySelector('[data-cart-inner]');
    if (!fresh || !cur) return null;
    /* keyboard focus survives the re-render: remember the control, then put focus on its twin */
    var ae = document.activeElement, keep = null;
    if (ae && cur.contains(ae)) {
      var it = ae.closest('[data-line]');
      keep = it ? { line: it.getAttribute('data-line'), idx: [].indexOf.call(it.querySelectorAll('button'), ae) } : { line: null };
    }
    cur.innerHTML = fresh.innerHTML;
    if (keep) {
      var target = null;
      if (keep.line) {
        var ni = cur.querySelector('.cd-item[data-line="' + keep.line + '"]');
        if (ni) target = ni.querySelectorAll('button')[keep.idx];
        if (!target) target = cur.querySelector('.cd-item .cd-qty button, .cd-empty a');
      }
      if (!target) target = cur.querySelector('[data-cart-close].iconbtn');
      if (target) target.focus({ preventScroll: true });
    }
    var n = parseInt(fresh.getAttribute('data-item-count'), 10);
    cur.setAttribute('data-item-count', isNaN(n) ? '' : n);
    if (!isNaN(n)) { setCount(n); return n; }
    return null;
  }

  function refreshCart() {
    return fetch(R.cart + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var n = applyDrawer(html);
        if (n !== null) return { item_count: n };
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) { setCount(cart.item_count); return cart; });
      });
  }

  function changeLine(line, qty) {
    var inner = document.querySelector('[data-cart-inner]');
    if (inner) inner.classList.add('cd-busy');
    return fetch(R.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refreshCart).catch(function () {}).then(function () {
      var cur = document.querySelector('[data-cart-inner]');
      if (cur) cur.classList.remove('cd-busy');
      var out = document.querySelector('.cd-item[data-line="' + line + '"] .cd-qty output');
      if (out && qty > 0 && !reduceMotion) { out.classList.remove('tick'); void out.offsetWidth; out.classList.add('tick'); }
    });
  }

  /* cart buttons (delegated, so they keep working after the drawer re-renders) */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open) {
      if (drawer()) { e.preventDefault(); refreshCart().then(openCart); }
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    var q = e.target.closest('[data-qty]');
    if (q) {
      var item = q.closest('[data-line]');
      if (item) {
        var ln = parseInt(item.getAttribute('data-line'), 10), qt = parseInt(q.getAttribute('data-qty'), 10);
        if (qt === 0 && !reduceMotion) {
          item.style.maxHeight = item.offsetHeight + 'px';
          void item.offsetHeight;
          item.classList.add('is-removing');
          setTimeout(function () { changeLine(ln, qt); }, 200);
        } else { changeLine(ln, qt); }
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMenu();
    closeCart();
  });

  /* add to cart: any <form data-cart-form> posts without leaving the page */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btns = [].slice.call(form.querySelectorAll('[type=submit]')).concat([].slice.call(document.querySelectorAll('[data-sticky-add]')));
    var keeps = btns.map(function (b) { return b.textContent; });
    var added = false;
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding...'; });
    var errEl = form.querySelector('[data-cart-error]'); if (errEl) errEl.hidden = true;
    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);
    fetch(R.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function (j) {
        var html = j && j.sections && j.sections['cart-drawer'];
        added = true;
        if (html && applyDrawer(html) !== null) return;
        return refreshCart();
      })
      .then(openCart)
      .catch(function (err) {
        var msg = form.querySelector('[data-cart-error]');
        if (!msg) { msg = document.createElement('p'); msg.setAttribute('data-cart-error', ''); msg.style.cssText = 'color:#b3261e;font-size:14px;margin-top:8px'; form.appendChild(msg); }
        msg.setAttribute('role', 'alert');
        msg.textContent = (err && err.message) ? err.message : 'Could not add to cart. Please try again.';
        msg.hidden = false;
        /* the Add to cart button may be the sticky bar, so bring the message into view */
        var mr = msg.getBoundingClientRect();
        if (mr.top < 0 || mr.bottom > window.innerHeight) { msg.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' }); }
      })
      .then(function () {
        function restore() { btns.forEach(function (b, i) { b.disabled = false; b.classList.remove('is-added'); b.textContent = keeps[i]; }); }
        if (added) {
          btns.forEach(function (b) { b.textContent = '\u2713 Added'; b.classList.add('is-added'); });
          setTimeout(restore, 1200);
        } else { restore(); }
      });
  });

  /* ---------- announcement bar: messages slide every 5 seconds, pause on hover, tap a code to copy ---------- */
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var s = [].slice.call(bar.querySelectorAll('.slide-a')), i = 0, paused = false;
    if (s.length < 2 || reduceMotion) return;
    function show(n) { s[i].classList.remove('is-active'); i = n; s[i].classList.add('is-active'); }
    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    setInterval(function () { if (!paused) show((i + 1) % s.length); }, 5000);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy-code]'); if (!b) return;
    var code = b.getAttribute('data-copy-code'), keep = b.innerHTML;
    function done() { b.textContent = 'Code ' + code + ' copied'; setTimeout(function () { b.innerHTML = keep; }, 1800); }
    function fail() { b.textContent = 'Could not copy. Code: ' + code; setTimeout(function () { b.innerHTML = keep; }, 4000); }
    try { navigator.clipboard.writeText(code).then(done, fail); } catch (err) { fail(); }
  });

  window.IRELIO = window.IRELIO || {};
  window.IRELIO.openCart = openCart;
  window.IRELIO.closeCart = closeCart;
})();
